import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import s from "./EditBrokerApplication.module.scss";
import {
  Button,
  Col,
  Divider,
  Form,
  Modal,
  notification,
  Row,
  Select,
  Table,
  Tooltip,
  Upload,
} from "antd";
import { useForm } from "antd/es/form/Form";
import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  FileOutlined,
  PaperClipOutlined,
  PlusCircleOutlined,
  UploadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { ICreateApplicationResponse, IRouteCountries } from "../../types";
import type { TableColumnsType, UploadProps } from "antd";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  addMessage,
  changeStatus,
  deleteApplicationFiles,
  deleteApplicationRoutes,
  getApplicationDetails,
  getApplicationsList,
  getBrokerOtherApplicationDetails,
  getBrokersApplicationDetails,
  getCountriesWithPosts,
  getManagerServicesByCountry,
  updateApplication,
} from "../../redux/ApplicationSlice";
import { UploadFile } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { PhoneInput } from "react-international-phone";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import Footer from "../../components/Footer/Footer";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import moment from "moment";
import Loading from "../../components/Loading/Loading";
import { useTranslation } from "react-i18next";
import { ColumnsType } from "antd/es/table";
import { getListStatusTag, getStatusTag } from "../../utils/functions";
import MobileDeclarantTable from "../../components/MobileDeclarantTable/MobileDeclarantTable";
import { getStatus, statuses } from "../../data";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import TextArea from "antd/es/input/TextArea";
import { Typography } from "antd";
var FileSaver = require("file-saver");

const { Title } = Typography;
const { Option } = Select;

const props: UploadProps = {
  action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
  onChange({ file, fileList }) {
    if (file.status !== "uploading") {
      console.log(file, fileList);
    }
  },
  beforeUpload: () => false,
  defaultFileList: [],
};

export interface TableData {
  number: number;
  lrn_code: string;
  declaration: React.ReactNode;
  key: number;
  date: string;
}

export interface ServiceTableType {
  number: number;
  status: React.ReactNode;
  service_name: string;
  service_price: string;
  broker: string;
  comment: string;
  result: JSX.Element;
  update: JSX.Element;
}

export interface UploadTableType {
  id: string;
  number?: number;
  name: string;
  upload_file?: string;
}

export interface EditTableType {
  number: number;
  application_number?: string;
  created_at?: string;
  status?: string;
  comments?: [];
  price?: number | string;
  status_change_dates?: string;
  user?: string;
  actions: string;
}

const EditBrokerApplication: React.FC = () => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const [form] = useForm();
  const [form2] = useForm();
  const params = useParams();
  const role = useSelector((state: RootState) => state.auth.role);
  const application = useSelector(
    (state: RootState) => state.application.application,
  );
  const countries = useSelector(
    (state: RootState) => state.application.countries,
  );

  const [isEditStatus, setIsEditStatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedRouteId, setSelectedRouteId] = useState<number | null>(null);
  const [selectedServiceId, setSelectedServiceId] = useState<number | null>(
    null,
  );
  const [files, setFiles] = useState<Record<string, UploadFile<any>[]>>({});
  const [serviceFiles, setServiceFiles] = useState<any>({});
  const loading = useSelector((state: RootState) => state.application.loading);
  const user = useSelector((state: RootState) => state.user.user);
  const [api, contextHolder] = notification.useNotification();
  const [changedValues, setChangedValues] =
    useState<Partial<ICreateApplicationResponse>>();
  const [isDisabled, setIsDisabled] = useState<boolean>(
    application?.status === "incomplete" ? true : false,
  );
  const currentPage = useSelector(
    (state: RootState) => state.application.currentPage,
  );
  const [deletedRouteIds, setDeletedRouteIds] = useState<number[]>([]);
  const [deletedFilesIds, setDeletedFilesIds] = useState<number[]>([]);

  const openNotification =
    (pauseOnHover: boolean, title: string, type: "success" | "error") => () => {
      let icon;
      switch (type) {
        case "success":
          icon = <CheckCircleOutlined style={{ color: "green" }} />;
          break;

        case "error":
          icon = <WarningOutlined style={{ color: "red" }} />;
          break;
      }
      api.open({
        message: title,
        icon,
        showProgress: true,
        pauseOnHover,
      });
    };
  const dispatch: AppDispatch = useDispatch();
  const [phone, setPhone] = useState(user?.phone);
  const managerServices = useSelector(
    (state: RootState) => state.application.managerServices,
  );

  const uploadTableData = [
    { id: "invoice", name: t("Инвойс (документ сопровождающий груз)") },
    {
      id: "customs_declaration_files",
      name: t("Экспортная/ Транзитная декларация"),
    },
    {
      id: "transport",
      name: t("Транспортный документ (CMR, Bill of Lading,...)"),
    },
    { id: "tech_passport_file", name: t("Техпаспорт") },
    { id: "drivers_passport", name: t("Паспорт водителя") },
    { id: "supporting", name: t("Прочая документация") },
  ];

  const data: EditTableType[] = [
    {
      number: 1,
      application_number: application?.application_number,
      created_at: application?.created_at,
      status: application?.status,
      comments: application?.comments,
      price: application?.price ? application.price : "-",
      user: "",
      actions: t("Редактирование"),
    },
  ];

  const columns: ColumnsType<EditTableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Дата регистрации заявки"),
      dataIndex: `registration_date`,
      width: 600,
      align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Cумма к оплате, $"),
      dataIndex: `price`,
      width: 600,
      align: "center",
    },
    {
      title: t("Дата изменения статуса"),
      dataIndex: `status_change_dates`,
      width: 600,
      render: (text) => <div className={s.font}>{text}</div>,
    },
  ];

  const columns2: ColumnsType<EditTableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 100,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Дата регистрации заявки"),
      dataIndex: `registration_date`,
      width: 180,
      align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Комментарии"),
      dataIndex: `comments`,
      width: 400,
    },
    {
      title: t("Дата изменения статуса"),
      dataIndex: `status_change_dates`,
      width: 200,
      align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },
  ];
  const serviceColumns: ColumnsType<ServiceTableType> = [
    {
      title: "№",
      dataIndex: "number",
      width: 50,
      align: "center",
    },
    {
      title: t("Статус"),
      dataIndex: "status",
      width: 150,
    },
    {
      title: t("Услуга"),
      dataIndex: "service_name",
      width: 300,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Cтоимость"),
      dataIndex: "service_price",
      width: 150,
      align: "center",
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Таможенный брокер"),
      dataIndex: "broker",
      width: 200,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Комментарии"),
      dataIndex: "comment",
      width: 300,
    },
    {
      title: t("Результат"),
      dataIndex: "result",
      width: 50,
      align: "center",
    },
    {
      title: t("Обновить"),
      dataIndex: "update",
      width: 50,
      align: "center",
    },
  ];

  useEffect(() => {
    dispatch(getManagerServicesByCountry());
    dispatch(getCountriesWithPosts());
  }, [dispatch]);

  useEffect(() => {
    if (application) {
      form.setFieldsValue({
        shipper_country: application.shipper_country,
        destination_country: application.destination_country,
        contact_phone: application.contact_phone,
        vehicle_number: application.vehicle_number,
        contact_email: application.contact_email,
        status: application.status,
        created_at: application.created_at,
        driver_name: application.driver_name,
        container_number:
          application.container_number === "undefined"
            ? "-"
            : application.container_number,

        customs_seal_numbers:
          application.customs_seal_numbers === "undefined"
            ? "-"
            : application.customs_seal_numbers,
        routes: application.routes?.map((it) => ({
          id: it.id,
          transit_country: it.transit_country,
          entry_customs_checkpoint: it.entry_customs_checkpoint,
          exit_customs_checkpoint: it.exit_customs_checkpoint,
          partner_company: it.service_owner_name,
          services: it.services,
          status: it.status,
          is_editable: it.is_editable,
          is_destination: it.is_destination,
        })),
      });
    }

    if (application?.files && Array.isArray(application.files)) {
      const mappedFiles: Record<string, UploadFile<any>[]> = {};

      application.files.forEach((f) => {
        if (!mappedFiles[f.file_type]) {
          mappedFiles[f.file_type] = [];
        }
        mappedFiles[f.file_type].push({
          uid: String(f.id),
          name: f.file_name_display || f.file_name,
          status: "done",
          url: f.file,
        });
      });

      setFiles(mappedFiles);
      form.setFieldsValue(mappedFiles);
    }

    const routeServiceFiles = application?.routes.flatMap((route) =>
      route.services.map((service) => ({
        id: service.id,
        routeId: route.id,
        files: service.files.map((f: any) => ({
          id: f.id,
          fileType: f.file_type,
          fileName: f.file_name_display || f.file_name,
          url: f.file,
          uploadedAt: f.uploaded_at,
        })),
      })),
    );

    setServiceFiles(routeServiceFiles);
  }, [application]);

  const handleChange =
    (recordId: string) => (info: { fileList: UploadFile<any>[] }) => {
      setFiles((prev) => ({
        ...prev,
        [recordId]: info.fileList,
      }));
      form.setFieldsValue({
        [recordId]: info.fileList,
      });
    };

  const UploadTableColums: TableColumnsType<UploadTableType> = [
    { dataIndex: "number", title: "№", width: 50, align: "center" },
    { dataIndex: "name", title: t("Наименование документа"), width: 500 },
    {
      title: t("Прикрепленные документы"),
      width: 300,
      dataIndex: "upload",
      render: (_: any, record: UploadTableType) => {
        return (
          <div className={s.table_upload}>
            <Form.Item
              name={record.id}
              rules={[
                {
                  validator: (_, value) =>
                    value && value.length > 0
                      ? Promise.resolve()
                      : Promise.reject(new Error("Загрузите файл")),
                },
              ]}
            >
              <Upload
                {...props}
                beforeUpload={() => false}
                fileList={files[record.id] || []}
                onChange={handleChange(record.id)}
                onRemove={(file) => {
                  if (!file.originFileObj) {
                    setDeletedFilesIds((prev) => [...prev, Number(file.uid)]);
                  }

                  setFiles((prev) => {
                    const currentFiles = prev[record.id] || [];
                    const newFiles = currentFiles.filter(
                      (f) => f.uid !== file.uid,
                    );

                    form.setFieldsValue({
                      [record.id]: newFiles,
                    });

                    return {
                      ...prev,
                      [record.id]: newFiles,
                    };
                  });

                  return true;
                }}
              >
                {!isDisabled && (
                  <Button
                    icon={<UploadOutlined />}
                    className={s.upload_table_btn}
                  >
                    Upload
                  </Button>
                )}
              </Upload>
            </Form.Item>
          </div>
        );
      },
    },
  ];

  const onValuesChange = (
    changed: Partial<ICreateApplicationResponse>,
    allValues: ICreateApplicationResponse,
  ) => {
    setChangedValues((prev) => {
      const newValues: Partial<ICreateApplicationResponse> = { ...prev };

      if (changed.routes && Array.isArray(changed.routes)) {
        const prevRoutes = prev?.routes || [];

        newValues.routes = allValues.routes.map((row, index) => {
          const prevRowChanges = prevRoutes[index] || {};
          const changedRow =
            (changed.routes as Partial<IRouteCountries>[])[index] || {};

          return { ...prevRowChanges, ...changedRow };
        });
      }

      Object.keys(changed).forEach((key) => {
        if (key !== "routes") {
          (newValues as any)[key] = (changed as any)[key];
        }
      });

      return newValues;
    });
  };

  const updateForm = async () => {
    try {
      const data = new FormData();

      if (changedValues) {
        if (changedValues.routes?.length) {
          const changedRoutes = changedValues.routes
            .map((row, index) => {
              const originalRow = application?.routes[index];

              if (!originalRow) {
                const cleanRow: any = {};

                for (const key in row) {
                  const value = (row as any)[key];
                  if (value && value !== undefined && value !== null) {
                    cleanRow[key] = value?.value ?? value;
                  }
                }

                return Object.keys(cleanRow).length > 0 ? cleanRow : null;
              }

              const updatedFields: any = {};
              for (const key in row) {
                const typedKey = key as keyof typeof row;
                const newValue = (row[typedKey] as any)?.value ?? row[typedKey];
                const oldValue =
                  (originalRow[typedKey] as any)?.id ?? originalRow[typedKey];

                if (newValue !== oldValue) {
                  updatedFields[typedKey] = newValue;
                }
              }

              if (Object.keys(updatedFields).length > 0) {
                return { id: originalRow.id, ...updatedFields };
              }
              return null;
            })
            .filter(Boolean);

          if (changedRoutes.length > 0) {
            data.append("routes", JSON.stringify(changedRoutes));
          }
        }
        for (const [key, value] of Object.entries(changedValues)) {
          if (key !== "routes") {
            data.append(key, JSON.stringify(value));
          }
        }
      }

      if (deletedRouteIds?.length > 0) {
        const res = await dispatch(
          deleteApplicationRoutes({
            id: Number(params.id),
            route_ids: deletedRouteIds,
          }),
        );
      }

      if (deletedFilesIds.length) {
        const res = await dispatch(
          deleteApplicationFiles({
            id: Number(params.id),
            file_ids: deletedFilesIds,
          }),
        );

        if (res.type === "applications/deleteApplicationFiles/fulfilled") {
          setDeletedFilesIds([]);
        }
      }

      Object.entries(files).forEach(([fieldName, fileList]) => {
        fileList.forEach((fileItem) => {
          if (fileItem.originFileObj) {
            data.append(fieldName, fileItem.originFileObj);
          }
        });
      });

      const res = await dispatch(
        updateApplication({ id: Number(params.id), formData: data }),
      );

      if (res.type === "applications/updateApplication/fulfilled") {
        dispatch(getApplicationDetails(Number(params.id)));
        openNotification(true, t("Вы обновили заявление!"), "success")();

        await dispatch(
          addMessage({
            application: Number(params.id),
            content: t(
              t(
                `Данные откорректированы, заявка готова к дальнейшему рассмотрению`,
              ),
            ),
            application_status: "corrected",
          }),
        );
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const addNewRoute = () => {
    const routes = form.getFieldValue("routes") || [];
    form.setFieldsValue({
      routes: [
        ...routes,
        {
          transit_country: undefined,
          entry_customs_checkpoint: undefined,
          exit_customs_checkpoint: undefined,
          partner_company: undefined,
          service: undefined,
          status: "new",
        },
      ],
    });
  };

  const deleteRoute = (index: number, remove: (index: number) => void) => {
    const currentRoutes = form.getFieldValue("routes") || [];
    const removed = currentRoutes[index];

    if (removed?.id) {
      setDeletedRouteIds((prev) => [...prev, removed.id]);
    }

    remove(index);
  };

  const setNewStatus = async (values: any) => {
    const data = new FormData();
    if (!selectedRouteId) return;

    if (
      (changedValues?.status === "completed" ||
        changedValues?.status === "paid") &&
      selectedRouteId
    ) {
      data.append("id", String(selectedRouteId));
      //data.append("status", values.status);
      data.append(
        "routes",
        JSON.stringify([
          {
            id: selectedRouteId,
            services: [{ id: selectedServiceId, status: values.status }],
          },
        ]),
      );
      data.append(`service_file_${selectedServiceId}`, declarationFile);

      const res = await dispatch(
        changeStatus({ id: Number(params.id), params: data }),
      );

      if (res.type === "applications/changeStatus/fulfilled") {
        dispatch(getBrokerOtherApplicationDetails(Number(params.id)));
        openNotification(true, t("Вы обновили статус!"), "success")();
        setIsEditStatus(false);
      }
    } else {
      if (selectedServiceId) {
        const res = await dispatch(
          changeStatus({
            id: Number(params.id),
            params: {
              id: selectedRouteId,
              services: [
                {
                  id: selectedServiceId,
                  status: values.status,
                  comment: values.comments,
                },
              ],
            },
          }),
        );
        if (res.type === "applications/changeStatus/fulfilled") {
          dispatch(getBrokerOtherApplicationDetails(Number(params.id)));
          openNotification(true, t("Вы обновили статус!"), "success")();
          setIsEditStatus(false);
        }
      }
    }
  };

  const handleOk = () => {
    setIsEditStatus(false);
  };

  const handleCancel = () => {
    setIsEditStatus(false);
  };

  type CustomUploadFile = UploadFile & { originFileObj?: File };
  const [declarationFile, setDeclarationFile] = useState<any>();

  const handleFileChange = (
    file: UploadFile,
    // setFileState: React.Dispatch<React.SetStateAction<CustomUploadFile>>
  ) => {
    setDeclarationFile(file);
    //setFileState(file as CustomUploadFile);
  };

  const [isDeclaratonModalOpen, setIsDeclarationModalOpen] = useState(false);

  const showDeclarationModal = () => {
    setIsDeclarationModalOpen(true);
  };

  const handleDeclarationOk = () => {
    setIsDeclarationModalOpen(false);
  };

  const handleDeclarationCancel = () => {
    setIsDeclarationModalOpen(false);
    setSelectedRouteId(null);
  };

  const downloadFile = async (fileUrl: string) => {
    if (!fileUrl) return;

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error("Failed to fetch the file");

      const blob = await response.blob();

      const filename = fileUrl.split("/").pop() || "file.pdf";

      FileSaver.saveAs(blob, filename);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const getMimeTypeByExtension = (filename: string) => {
    if (!filename) return undefined;
    const extension = filename.split(".").pop()?.toLowerCase();
    const mimeTypes: { [key: string]: string } = {
      pdf: "application/pdf",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      doc: "application/msword",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      jpeg: "image/jpeg",
      jpg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      txt: "text/plain",
      csv: "text/csv",
      zip: "application/zip",
    };
    return extension ? mimeTypes[extension] : undefined;
  };
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [selectedComments, setSelectedComments] = useState<any[]>([]);

  const handleCommentsClick = (comments: any[]) => {
    setSelectedComments(comments);
    setIsCommentsModalOpen(true);
  };

  const handleCommentsCancel = () => {
    setIsCommentsModalOpen(false);
    setSelectedComments([]);
  };

  return (
    <div className={s.wrapper}>
      {contextHolder}
      {width > 700 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <Link
          to={
            role === "broker"
              ? "/brokersApplications"
              : role === "admin"
                ? "/admin/applications"
                : "/managerApplications"
          }
          className={s.back}
          onClick={() => dispatch(getApplicationsList(currentPage))}
        >
          <ArrowLeftOutlined className={s.backIcon} /> {t("Назад")}
        </Link>
        <div className={s.table}>
          {width > 700 ? (
            <Table<EditTableType>
              bordered
              pagination={false}
              columns={
                application?.status === "incomplete" ? columns2 : columns
              }
              className="table"
              dataSource={data?.map((it, index) => ({
                number: index + 1,
                application_number: it?.application_number,
                registration_date: moment(it?.created_at).format(
                  "DD.MM.YYYY - HH:mm",
                ),
                status: it?.status,
                comments: it?.comments,
                price:
                  application?.price && Number(application?.price) > 0
                    ? application.price
                    : "-",
                user: it?.user,
                actions: it.actions,
              }))}
            />
          ) : (
            <MobileDeclarantTable
              dataSource={data?.map((it) => ({
                ...it,
              }))}
            />
          )}
        </div>
        <div className={s.form}>
          <Form
            layout="vertical"
            className={"create_application"}
            form={form}
            onFinish={updateForm}
            onValuesChange={onValuesChange}
          >
            <Row gutter={[10, 4]}>
              <Col span={width > 900 ? 4 : 24}>
                <Form.Item
                  name="shipper_country"
                  label={
                    <div className={s.bold}>{t("Страна грузоотправитель")}</div>
                  }
                  initialValue={{
                    value: application?.shipper_country,
                    label: application?.shipper_country_name,
                  }}
                  rules={[
                    {
                      required: true,
                      message: t("Выберите страну грузоотправителя"),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    className={s.select}
                    disabled={isDisabled}
                    placeholder={t("Выберите страну")}
                    options={countries?.map((it) => ({
                      value: it?.id,
                      label: it?.transit_country_name,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 5 : 24}>
                <Form.Item
                  name="vehicle_number"
                  label={t("№ транспортного средства")}
                  rules={[
                    {
                      required: true,
                      message: t("Введите № транспортного средства"),
                    },
                  ]}
                >
                  <input
                    disabled={isDisabled}
                    placeholder={t("Введите № транспортного средства")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 5 : 20}>
                <Form.Item name="container_number" label={t("№ контейнера")}>
                  <input
                    disabled={isDisabled}
                    placeholder={t("Укажите № контейнера")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 10 : 24}>
                <Form.Item
                  name="customs_seal_numbers"
                  label={t("Номера таможенных пломб")}
                >
                  <TextArea
                    disabled={isDisabled}
                    autoSize={{ minRows: 1, maxRows: 3 }}
                    placeholder={t("Укажите номера таможенных пломб")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
              {/* <Col span={2}>
                <Form.Item label=" ">
                  <button
                    type="button"
                    className={s.add_route_btn}
                    //onClick={() => addRouteRef.current?.()}
                  >
                    <PlusCircleOutlined className={s.plus_icon} />
                    &nbsp;&nbsp; Добавить маршрут
                  </button>
                </Form.Item>
              </Col> */}
            </Row>

            <Form.List
              name="routes"
              initialValue={
                Array.isArray(application?.routes)
                  ? application?.routes.map((it) => ({
                      id: it.id,
                      transit_country: {
                        value: it.transit_country,
                        label: it.transit_country_name,
                      },
                      entry_customs_checkpoint: {
                        value: it.entry_customs_checkpoint,
                        label: it.entry_customs_name,
                      },
                      exit_customs_checkpoint: {
                        value: it.exit_customs_checkpoint,
                        label: it.exit_customs_name,
                      },
                      partner_company: {
                        value: it.service_owner,
                        label: `${it.transit_country_name} -  ${it.service_owner_email}`,
                      },
                      services: it.services.map((el) => ({
                        value: el.service_id,
                        label: `$${el.service_price} -  ${el.service_name}`,
                      })),
                      status: it.status,
                      is_editable: it.is_editable,
                      is_destination: it.is_destination,
                    }))
                  : []
              }
            >
              {(fields, { remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => {
                    const route = form.getFieldValue(["routes", name]);
                    const isEditable = route?.is_editable;
                    return (
                      <div
                        className={
                          Array.isArray(fields) && fields.length > 0
                            ? isEditable
                              ? s.editable_dynamic_fields
                              : s.dynamic_fields
                            : ""
                        }
                      >
                        <Row
                          gutter={[12, 0]}
                          style={{
                            width: "99%",
                            marginLeft: "5px",
                          }}
                        >
                          <div>
                            {" "}
                            <Title level={5} className={s.route_title}>
                              {route?.is_destination
                                ? t("Страна грузополучателя")
                                : t("Страна транзита")}
                            </Title>
                          </div>
                          <Col span={6}>
                            <Form.Item
                              {...restField}
                              name={[name, "transit_country"]}
                              label={t("Страна")}
                              rules={[
                                {
                                  required: true,
                                  message: t("Страна транзита"),
                                },
                              ]}
                            >
                              <Select
                                showSearch
                                //disabled={isDisabled}
                                className={s.select}
                                placeholder={t("Выберите страну")}
                                options={countries?.map((it) => ({
                                  value: it?.id,
                                  label: it?.transit_country_name,
                                }))}
                                onChange={() => {
                                  form.setFields([
                                    {
                                      name: [
                                        "routes",
                                        name,
                                        "entry_customs_checkpoint",
                                      ],
                                      value: undefined,
                                    },
                                    {
                                      name: [
                                        "routes",
                                        name,
                                        "exit_customs_checkpoint",
                                      ],
                                      value: undefined,
                                    },
                                    {
                                      name: ["routes", name, "partner_company"],
                                      value: undefined,
                                    },
                                    {
                                      name: ["routes", name, "service"],
                                      value: undefined,
                                    },
                                  ]);
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={7}>
                            <Form.Item
                              noStyle
                              shouldUpdate={(prevValues, currentValues) =>
                                prevValues.routes?.[name]?.transit_country !==
                                currentValues.routes?.[name]?.transit_country
                              }
                            >
                              {({ getFieldValue }) => {
                                const routes = (getFieldValue("routes") ||
                                  []) as any[];
                                const route = routes[name];
                                const selectedCountryId =
                                  route?.transit_country;
                                const selectedCountryName =
                                  managerServices?.find(
                                    (c) => c.id === selectedCountryId,
                                  )?.transit_country_name;
                                // const selectedManager = managerServices?.find(
                                //   (c) => c.id === selectedCountryId
                                // )?.companies;
                                return (
                                  <Form.Item
                                    {...restField}
                                    name={[name, "partner_company"]}
                                    label={t("Региональный представитель")}
                                    rules={[
                                      {
                                        required: true,
                                        message: t(
                                          "Выберите компанию партнера",
                                        ),
                                      },
                                    ]}
                                  >
                                    <Select
                                      className={s.select}
                                      placeholder={t("Компания")}
                                      // options={selectedManager?.map((it) => ({
                                      //   value: it?.id,
                                      //   label: (
                                      //     <div>
                                      //       {`
                                      //       ${it.company_name}`}
                                      //     </div>
                                      //   ),
                                      // }))}
                                      onChange={() => {
                                        form.setFieldValue(
                                          ["routes", name, "service"],
                                          undefined,
                                        );
                                      }}
                                    />
                                  </Form.Item>
                                );
                              }}
                            </Form.Item>
                          </Col>
                          <Col span={11}>
                            <Form.Item
                              noStyle
                              shouldUpdate={(prevValues, currentValues) =>
                                prevValues.routes?.[name]?.transit_country !==
                                currentValues.routes?.[name]?.transit_country
                              }
                            >
                              {({ getFieldValue }) => {
                                const routes = (getFieldValue("routes") ||
                                  []) as any[];
                                const route = routes[name];
                                const selectedCountryId =
                                  route?.transit_country;
                                const selectedCountry = countries?.find(
                                  (c) => c.id === selectedCountryId,
                                );

                                return (
                                  <Form.Item
                                    {...restField}
                                    name={[name, "entry_customs_checkpoint"]}
                                    label={t(
                                      "Въездной - Выездной таможенный пункт",
                                    )}
                                    rules={[
                                      {
                                        required: true,
                                        message: t(
                                          "Выберите въездной - выездной таможенный контрольно-пропускной пункт",
                                        ),
                                      },
                                    ]}
                                  >
                                    <Select
                                      placeholder={t(
                                        "Выездной - выездной таможенный контрольно - пропускной пункт",
                                      )}
                                      className={s.select}
                                      popupClassName={"customSelectDropdown"}
                                      options={selectedCountry?.bordered_countries.map(
                                        (it) => ({
                                          label: (
                                            <Divider plain orientation="center">
                                              <span
                                                className={
                                                  s.bordered_countries_names
                                                }
                                              >
                                                {it.bordered_country_names}
                                              </span>
                                            </Divider>
                                          ),
                                          title: it?.bordered_country_names,
                                          options: it.offices.map((el) => ({
                                            label: (
                                              <span className={s.post_name}>
                                                {el.customs_name}
                                              </span>
                                            ),
                                            value: el.id,
                                          })),
                                        }),
                                      )}
                                    />
                                  </Form.Item>
                                );
                              }}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row style={{ width: "98%", margin: "0 auto" }}>
                          <Col span={24}>
                            <Form.Item
                              noStyle
                              shouldUpdate={(prevValues, currentValues) =>
                                prevValues.routes?.[name]?.partner_company !==
                                currentValues.routes?.[name]?.partner_company
                              }
                            >
                              {({ getFieldValue }) => {
                                const routes = getFieldValue("routes") || [];
                                const route = routes?.[name];
                                const selectedCountryId =
                                  route?.transit_country;
                                const selectedCompanyId =
                                  route?.partner_company;

                                const country = managerServices?.find(
                                  (c) => c.id === selectedCountryId,
                                );
                                const route_services = application?.routes.find(
                                  (it) => it.id === route.id,
                                )?.services;
                                return (
                                  <Form.Item
                                    {...restField}
                                    name={[name, "services"]}
                                    label={t("Услуги")}
                                    rules={[
                                      {
                                        required: true,
                                        message: t("Услуги"),
                                      },
                                    ]}
                                  >
                                    <Table<ServiceTableType>
                                      className={s.service_table}
                                      columns={serviceColumns}
                                      pagination={false}
                                      dataSource={route_services?.map(
                                        (it: any, index: number) => ({
                                          number: index + 1,
                                          status: getStatusTag(
                                            it.status,
                                            "sm",
                                            t,
                                          ),
                                          service_name: it?.service_name,
                                          service_price: `$${it.service_price}`,
                                          broker: it.broker_name,
                                          comment: it?.comment
                                            ? it?.comment
                                            : "-",
                                          result: (
                                            <div
                                              onClick={() => {
                                                setIsDeclarationModalOpen(true);
                                                setSelectedRouteId(route?.id);
                                                setSelectedServiceId(it.id);
                                              }}
                                            >
                                              <FileOutlined />
                                            </div>
                                          ),
                                          update: (
                                            <div
                                              onClick={() => {
                                                setIsEditStatus(true);
                                                setSelectedRouteId(route?.id);
                                                setSelectedServiceId(it.id);
                                              }}
                                            >
                                              <EditOutlined />
                                            </div>
                                          ),
                                        }),
                                      )}
                                    ></Table>
                                  </Form.Item>
                                );
                              }}
                            </Form.Item>
                          </Col>
                        </Row>
                        <Col className={s.btns_wrapper}>
                          <div className={s.btns_wrapper_inner}>
                            {fields.length > 1 && (
                              <Tooltip
                                placement="topRight"
                                title={t("Удалить маршрут")}
                                color={"gray"}
                              >
                                {!route?.is_destination && (
                                  <CloseCircleOutlined
                                    className={s.close_icon}
                                    onClick={() => deleteRoute(name, remove)}
                                  />
                                )}
                              </Tooltip>
                            )}
                            <Tooltip
                              placement="topRight"
                              title={t("Добавить маршрут")}
                              color={"gray"}
                            >
                              <PlusCircleOutlined
                                className={s.plus_icon}
                                onClick={() => addNewRoute()}
                              />
                            </Tooltip>
                          </div>{" "}
                          &nbsp;
                        </Col>
                      </div>
                    );
                  })}

                  {/* )) */}
                  {/* } */}
                </>
              )}
            </Form.List>
            {/* </Row> */}

            <Row gutter={[8, 24]}>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item name="driver_name" label={t("ФИО (Водителя)")}>
                  <input
                    value={phone}
                    className={s.input}
                    disabled={isDisabled}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item
                  name="contact_phone"
                  label={
                    width > 1091
                      ? t("Контактный телефон (Водителя)")
                      : t("Телефон (Водителя)")
                  }
                >
                  <PhoneInput
                    disabled={isDisabled}
                    defaultCountry="md"
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                    className={s.phone_input}
                  />
                </Form.Item>
              </Col>
              <Col span={width > 900 ? 6 : 12}>
                <Form.Item
                  name="contact_email"
                  label={
                    width > 1091
                      ? t("Контактный Email (Водителя)")
                      : t("Email (Водителя)")
                  }
                >
                  <input
                    placeholder={t("Введите Email")}
                    className={s.input}
                    disabled={isDisabled}
                  />
                </Form.Item>
              </Col>
            </Row>
            <h2 className={s.h2} style={{ width: "100%" }}>
              {t("Прикрепленные документы")}
            </h2>
            <Table<UploadTableType>
              columns={UploadTableColums}
              pagination={false}
              bordered
              dataSource={uploadTableData.map((it, index) => ({
                ...it,
                number: index + 1,
              }))}
            ></Table>
            <button className={s.btn} type="submit">
              {t("Обновить заявку")}
            </button>
          </Form>
        </div>
      </div>

      <Modal
        open={isEditStatus}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"80%"}
        className="modal"
        footer={null}
      >
        {isEditStatus && (
          <div className={s.editablePart}>
            <div className={s.title}>{t("Установите статус заказа")}</div>
            <Form
              form={form2}
              className={s.form}
              layout="vertical"
              onFinish={setNewStatus}
              onValuesChange={onValuesChange}
            >
              <Row gutter={[12, 6]}>
                <Col span={width > 800 ? 5 : 24}>
                  <Form.Item name="status" label={t("Текущий статус")}>
                    <Select
                      className={s.select}
                      placeholder={t("Выберите статус")}
                      options={
                        application?.is_owner
                          ? [
                              { value: "corrected", label: t("Исправлено") },
                              { value: "paid", label: t("Оплачен") },
                            ]
                          : getStatus(t)
                              .filter(
                                (el) =>
                                  el.value !== "new" &&
                                  el.value !== "corrected" &&
                                  el.value !== "payment_confirmed" &&
                                  el.value !== "paid",
                              )
                              .map((it) => ({
                                label: it.label,
                                value: it.value,
                              }))
                      }
                      onChange={(value) => {
                        setSelectedStatus(value);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={width > 800 ? 5 : 24}>
                  <Form.Item name="status" label={t("Изменить статус на")}>
                    <Select
                      className={s.select}
                      placeholder={t("Выберите статус")}
                      options={
                        application?.is_owner
                          ? [
                              { value: "corrected", label: t("Исправлено") },
                              { value: "paid", label: t("Оплачен") },
                            ]
                          : getStatus(t)
                              .filter(
                                (el) =>
                                  el.value !== "new" &&
                                  el.value !== "corrected" &&
                                  el.value !== "payment_confirmed" &&
                                  el.value !== "paid",
                              )
                              .map((it) => ({
                                label: it.label,
                                value: it.value,
                              }))
                      }
                      onChange={(value) => {
                        setSelectedStatus(value);
                      }}
                    />
                  </Form.Item>
                </Col>

                {(selectedStatus === "incomplete" ||
                  selectedStatus === "rejected") && (
                  <Col span={width > 800 ? 16 : 24}>
                    <Form.Item name="comments" label={t("Комментарии")}>
                      <textarea
                        placeholder={
                          selectedStatus === "incomplete"
                            ? t(
                                "Напишите какие пункты нуждаются в исправлении...",
                              )
                            : t("Напишите причину отказа")
                        }
                        className={s.input}
                        style={{
                          margin: 0,
                          minHeight: "80px",
                          background: "white",
                        }}
                      />
                    </Form.Item>
                  </Col>
                )}

                {selectedStatus === "ready_to_payment" && (
                  <Col span={width > 800 ? 19 : 24}>
                    <Row gutter={[10, 4]}></Row>
                  </Col>
                )}

                {selectedStatus === "completed" && (
                  <Col span={19}>
                    <Col span={6}>
                      <Form.Item
                        name="completed_document"
                        label={t("Загрузить документ")}
                        rules={[
                          {
                            required: true,
                            message: t("Загрузите декларацию"),
                          },
                        ]}
                      >
                        <Upload
                          accept="*"
                          {...props}
                          maxCount={1}
                          beforeUpload={() => false}
                          onChange={(info) => handleFileChange(info.file)}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            className={s.upload_btn}
                          >
                            {t("Загрузить")}
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Col>
                )}

                {selectedStatus === "paid" && (
                  <Col span={19}>
                    <Col span={6}>
                      <Form.Item
                        name="paid"
                        label={t("Прикрепить квитанцию")}
                        valuePropName="fileList"
                        getValueFromEvent={(e) => e && e.fileList}
                        rules={[
                          {
                            required: true,
                            message: t("Загрузите квитанцию"),
                          },
                        ]}
                      >
                        <Upload
                          accept="*"
                          {...props}
                          maxCount={1}
                          onChange={(info) => handleFileChange(info.file)}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            className={s.upload_btn}
                          >
                            {t("Загрузить")}
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Col>
                )}
              </Row>

              <div className={s.btns}>
                <button className={s.declaration_edit_btn}>
                  {t("Изменить")}
                </button>
              </div>
            </Form>
          </div>
        )}
      </Modal>

      <Modal
        title={t("Документ")}
        open={isDeclaratonModalOpen}
        onOk={handleDeclarationOk}
        onCancel={handleDeclarationCancel}
        width="50%"
        footer={null}
      >
        <div>
          {Array.isArray(serviceFiles) ? (
            (() => {
              const files =
                serviceFiles.find((it: any) => it.id === selectedServiceId)
                  ?.files || [];
              if (files.length === 0) return <div>{t("Нет файлов")}</div>;
              return files.map((file: any, index: number) => {
                const fileName = file.url
                  ? file.url.split("/").pop()
                  : `Файл ${index + 1}`;
                return (
                  <div key={index} style={{ marginBottom: 8 }}>
                    <a href={file.url} download={fileName}>
                      <PaperClipOutlined />
                      &nbsp;{fileName}
                    </a>
                  </div>
                );
              });
            })()
          ) : (
            <div>{t("Нет готовых документов")}</div>
          )}
        </div>
      </Modal>

      <Footer />
      {loading ? (
        <div className={s.loader}>
          <Loading loading={loading} />
        </div>
      ) : null}
    </div>
  );
};

export default EditBrokerApplication;
